// 교실 수업 상태 (3-store): 강사가 나에게 발언권을 줬나, 도구 막대에 한 번 보여 줄 안내, 서버로 보낼 발언권 요청.
// 값을 바꾸는 함수는 이 파일에만 있다. 규칙은 shared/world/classroom.ts, 컨트롤러는 2-controllers/meeting/classroom.ts.
export const CLASS: { granted: boolean; notice: string; outbox: { k: 'grant' | 'revoke'; id: string }[] } = { granted: false, notice: '', outbox: [] };
export function setMyGrant(on: boolean) { CLASS.granted = on; }
export function setNotice(text: string) { CLASS.notice = text; }
export function queueCls(k: 'grant' | 'revoke', id: string) { CLASS.outbox.push({ k, id }); }
export function takeCls() { return CLASS.outbox.splice(0); }
